module.exports = __webpack_public_path__ + "static/media/bn_banner.6ec80782.png";